import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "../context/AuthContext";
import { Loader2, ShieldCheck, ShieldAlert } from "lucide-react";

const LOGO_URL = "https://ixcateopandecuauhtemocgro.gob.mx/vendor/municipio/assets/img/logo.png";
const ESCUDO_URL = "https://ixcateopandecuauhtemocgro.gob.mx/vendor/municipio/assets/img/escudo.png";

export default function ValidationPage() {
  const { folio, token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Validaci\u00f3n de Permiso";
    axios
      .get(`${API}/validate/${folio}/${token}`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e?.response?.data?.detail || "Permiso no encontrado o token inv\u00e1lido"))
      .finally(() => setLoading(false));
  }, [folio, token]);

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#fff", display: "flex", flexDirection: "column", fontFamily: "'Poppins', sans-serif" }}>
      {/* Top orange nav */}
      <div style={{ backgroundColor: "#f58238", padding: "0.6rem 1rem" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", justifyContent: "center", gap: 28, color: "white", fontSize: "0.85rem", fontWeight: 600, letterSpacing: 0.5 }}>
          {["INICIO", "TR\u00c1MITES", "FAQ", "TRANSPARENCIA", "CONTACTO"].map((m) => (
            <span key={m} style={{ cursor: "pointer" }}>{m}</span>
          ))}
        </div>
      </div>

      {/* Submenu with logos */}
      <section style={{ padding: "1.5rem 1rem", backgroundColor: "#fff" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 2fr 1fr", alignItems: "center", gap: 20 }}>
          <div style={{ textAlign: "center" }}>
            <img src={LOGO_URL} alt="" style={{ maxWidth: 130, height: "auto" }} />
          </div>
          <h2 style={{ textAlign: "center", color: "#f58238", fontWeight: 700, fontSize: "1.65rem", margin: 0, lineHeight: 1.25 }}>
            Dirección de Tránsito del Ayuntamiento de Ixcateopan de Cuauhtémoc.
          </h2>
          <div style={{ textAlign: "center" }}>
            <img src={ESCUDO_URL} alt="" style={{ maxWidth: 130, height: "auto" }} />
          </div>
        </div>
      </section>

      {/* Banner */}
      <section style={{ padding: "0.5rem 1rem 1.5rem" }}>
        <h1 style={{ textAlign: "center", margin: 0, fontWeight: 800, fontSize: "2.4rem", color: "#1a1a1a", letterSpacing: 1 }}>
          {error ? "PERMISO NO V\u00c1LIDO" : data?.is_valid ? "PERMISO CERTIFICADO" : "PERMISO VENCIDO"}
        </h1>
        {data && (
          <div style={{ textAlign: "center", marginTop: 8 }}>
            {data.is_valid ? (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 8, color: "#10b981", fontWeight: 600 }}>
                <ShieldCheck size={20} /> Vigente y auténtico
              </span>
            ) : (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 8, color: "#ef4444", fontWeight: 600 }}>
                <ShieldAlert size={20} /> Documento vencido
              </span>
            )}
          </div>
        )}
      </section>

      {/* Verification */}
      <div style={{ padding: "1.5rem 1rem", backgroundColor: "#ffe3d1", flex: 1 }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          {loading ? (
            <div style={{ backgroundColor: "white", padding: 40, textAlign: "center", color: "#6b7280" }}>
              <Loader2 size={28} className="spin" /> Cargando...
            </div>
          ) : error ? (
            <div style={{ backgroundColor: "white", padding: 40, textAlign: "center", color: "#b91c1c", fontWeight: 600 }}>
              {error}
            </div>
          ) : (
            <div style={{ overflowX: "auto", backgroundColor: "white" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ borderBottom: "2px solid #e5e7eb", textAlign: "left" }}>
                    {["Folio", "Marca", "Línea", "Modelo", "Color", "Núm. Motor", "Núm. Serie", "Fecha Expedición", "Fecha Vencimiento"].map((h) => (
                      <th key={h} style={{ padding: "1rem 0.75rem", fontWeight: 700, color: "#1a1a1a", fontSize: "0.95rem" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={cellTd}>{data.folio}</td>
                    <td style={cellTd}>{data.marca}</td>
                    <td style={cellTd}>{data.linea}</td>
                    <td style={cellTd}>{data.modelo}</td>
                    <td style={cellTd}>{data.color}</td>
                    <td style={cellTd}>{data.motor_number}</td>
                    <td style={cellTd}>{data.serie}</td>
                    <td style={cellTd}>{data.fecha_expedicion}</td>
                    <td style={cellTd}>{data.fecha_vencimiento}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <footer style={{ backgroundColor: "#f58238", color: "white", padding: "2rem 1rem" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 30, alignItems: "start" }}>
          <div style={{ textAlign: "center" }}>
            <img src={LOGO_URL} alt="" style={{ maxWidth: 120, height: "auto", filter: "brightness(0) invert(1)", opacity: 0.9 }} />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12, fontSize: "0.85rem", fontWeight: 600 }}>
            <div style={{ display: "flex", gap: 18, flexWrap: "wrap", justifyContent: "center" }}>
              {["INICIO", "TR\u00c1MITES", "FAQ", "TRANSPARENCIA", "CONTACTO"].map((m) => (
                <span key={m} style={{ cursor: "pointer" }}>{m}</span>
              ))}
            </div>
            <div style={{ fontSize: "0.8rem", marginTop: 12, lineHeight: 1.5 }}>
              <b>2026-2030</b> H. Ayuntamiento de Ixcateopan de Cuauhtémoc, Guerrero.
              <p style={{ marginTop: 8 }}>
                Portal web de la dirección de tránsito y vialidad pública del municipio de Ixcateopan de Cuauhtémoc, Guerrero. En este portal podrás verificar la vigencia y autenticidad de los permisos y licencias expedidas por el municipio.
              </p>
            </div>
          </div>
          <div style={{ textAlign: "right", fontSize: "0.85rem", fontWeight: 600 }}>
            <span style={{ cursor: "pointer" }}>Política de privacidad</span>
            <span style={{ margin: "0 8px" }}>|</span>
            <span style={{ cursor: "pointer" }}>Términos y condiciones</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

const cellTd = { padding: "1rem 0.75rem", color: "#1f2937", fontSize: "0.92rem", fontWeight: 500 };
